var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkypilot = function SvgSkypilot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.786 197.604L119.366 203.054L212.553 296.228L197.566 238.369L156.786 197.604Z",
    fill: "#372F8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.543 0.178711L0.447266 84.1646L93.6277 177.319L102.384 137.178L62.2825 97.0855L253.238 43.3457C253.238 43.3457 291.154 5.64839 296.55 0.185504L296.543 0.178711Z",
    fill: "#372F8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.233 43.3408L197.567 238.369L212.554 296.221L296.551 0.173828C291.155 5.63671 253.239 43.334 253.239 43.334L253.233 43.3408Z",
    fill: "#372F8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.507 164.183L119.366 203.054L156.786 197.605L190.405 106.494L190.107 106.595L132.507 164.183Z",
    fill: "#195D7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.378 137.177L93.6221 177.324L132.508 164.186L190.108 106.599L102.378 137.177Z",
    fill: "#39A4DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkypilot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "86a0dc98705b7863934af7d85ff3973f.svg";